/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { getUserByToken, login, loginMasterApi } from '../core/_requests'
import { useAuth } from '../core/Auth'
import { validateRut, formatRut } from '../../../Functions'
import { Modal } from "react-bootstrap";
import SelectSearch from 'react-select'
import { getRutProfesionales } from '../../../Api'

const loginSchema = Yup.object().shape({
  username: Yup.string()
    .required('El RUT es obligatorio')
    .test('rut-validation', 'RUT inválido', (value) => validateRut(value || '')),
  password: Yup.string()
    // .min(3, 'Minimum 3 symbols')
    // .max(50, 'Maximum 50 symbols')
    .required('La Contraseña es obligatoria'),
})

const initialValues = {
  // email: 'admin@demo.com',
  // password: 'demo',
  username: '', // 17000000-0
  password: '',
}

const initialValuesMaster = {
  usuario: '',
  rut: '',
  token: '',
  error: '',
  username: ''
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

function LoginMasterComponent({ show, handleClose, userMaster, loading, loginMaster, setUserMaster }: any) {

  const [options, setOptions] = useState([]);

  const handleChange = (newValue: any) => {
    setUserMaster({ ...userMaster, rut: newValue.value, username: newValue.value })
  };
  const selectProfesional = async (value = "") => {
    if (value.length >= 3) {
      const _response: any = await getRutProfesionales({ search: value, rut: userMaster?.usuario, token: userMaster?.token });
      if (_response.status) {
        setOptions(_response.data);
      }
    }
  }
  const handleInputChange = (inputValue: any) => {
    selectProfesional(inputValue);
  };

  useEffect(() => {

  }, [options])

  return (
    <Modal show={show} size='lg' onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Seleccione Profesional</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-12">
            <label className="fs-4 fw-bold">Profesional</label>
            <SelectSearch
              options={options}
              onChange={handleChange}
              onInputChange={handleInputChange}
              noOptionsMessage={() => "Ingrese al menos 3 caracteres para buscar"}
              placeholder="Seleccione..."
            />
          </div>
          <div className="col-md-12" style={{ marginTop: '20px' }}>

            {userMaster?.error && <div className="mb-lg-15 alert alert-danger">
              <div className="alert-text font-weight-bold">
                {userMaster?.error}
              </div>
            </div>}
            <button
              type='button'
              className='btn btn-primary pull-right'
              disabled={userMaster?.rut.length === 0}
              onClick={loginMaster}
            >
              {!loading && <span className='indicator-label'>Ingreso</span>}
              {loading && (
                <span className='indicator-progress' style={{ display: 'block' }}>
                  Ingresando...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export function Login() {
  const [loading, setLoading] = useState(false)
  const { saveAuth, setCurrentUser } = useAuth()
  const [userMaster, setUserMaster] = useState(initialValuesMaster)
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const loginMaster = async () => {
    setLoading(true)
    try {
      const { data: auth } = await loginMasterApi(userMaster);
      const date = new Date();
      const dateExpired = Number(date.setTime(date.getTime() + (20 * 60 * 1000))); // Añadimos 20 minutos a la duración de la sessión
      saveAuth({ ...auth, dateExpired })
      const { data: user } = await getUserByToken(auth.access_token)
      setCurrentUser(user)
      handleClose();
      setLoading(false)
    } catch (error: any) {

      let rmessage = error?.response?.data?.rmessage || 'Error de autenticación';
      setUserMaster({ ...userMaster, error: rmessage })
      saveAuth(undefined)
      setLoading(false)
    }
  }

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {

      setLoading(true)
      setStatus('')
      setUserMaster(initialValuesMaster)
      try {
        const { data: auth } = await login(values.username, values.password);
        if (!auth.profesional) {
          setLoading(false)
          setUserMaster({ ...userMaster, token: auth?.access_token, usuario: values.username })
          handleShow()
          return;
        }
        const date = new Date();
        const dateExpired = Number(date.setTime(date.getTime() + (20 * 60 * 1000))); // Añadimos 20 minutos a la duración de la sessión
        saveAuth({ ...auth, dateExpired })
        const { data: user } = await getUserByToken(auth.access_token)
        setCurrentUser(user)
      } catch (error: any) {
        let errorMessage;
        if (error?.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else {
          errorMessage = 'Datos de inicio de sesión incorrectos';
        }
        console.error(error)
        saveAuth(undefined)
        setStatus(errorMessage)
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  const onChangeRut = async (ev: any) => {
    const formattedRut = formatRut(ev.target.value);
    await formik.setFieldValue("username", formattedRut)
  }

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-11'>
        {/* <div className='text-gray-500 fw-semibold fs-6'>Your Social Campaigns</div> */}
      </div>
      {/* begin::Heading */}

      {formik.status ? (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      ) : (<></>)}

      {/* begin::Form group */}
      <div className='fv-row mb-5'>
        <input
          placeholder='RUT*'
          {...formik.getFieldProps('username')}
          onChange={onChangeRut}
          className={clsx(
            'form-control bg-transparent',
            { 'is-invalid': formik.touched.username && formik.errors.username },
            {
              'is-valid': formik.touched.username && !formik.errors.username,
            }
          )}
          type='text'
          name='username'
          autoComplete='off'
        />
        {formik.touched.username && formik.errors.username && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.username}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-3'>
        <input
          type='password'
          placeholder='Contraseña'
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Wrapper */}
      <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-3'>
        <div />

        {/* begin::Link */}
        <Link to='/auth/forgot-password' className='link-primary'>
          ¿Olvidó su contraseña?
        </Link>
        {/* end::Link */}
      </div>
      {/* end::Wrapper */}

      {/* begin::Action */}
      <div className='d-grid mb-5'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-primary'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Ingreso</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Ingresando...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}

      <LoginMasterComponent 
        show={show}
        handleClose={handleClose}
        userMaster={userMaster}
        loading={loading}
        loginMaster={loginMaster}
        setUserMaster={setUserMaster}
      />
      
    </form>

  )
}
